import Footer from "../../footer"
import NavBar from "../../nav"

const InternationalProcedures = () => {
  return <div className='international-procedures'>
    <NavBar />
    <div>
    <section className="clean-block pfa-content clearfix">
			<div className="divider sections">
				<h1>International Procedures</h1>
				<div className="headline-divider sections"></div>
				<h2>Procedurally Oriented Manuals &amp; Standards</h2>
			</div>
		</section>
    <section className="clean-block show-checklists clearfix">
			<div className="container content-container sms-container">	
				<div className="container-fluid">
					<div className="row">
						<div className="col-sm checklist-item">
							<div className="checklist-container clearfix">
								<div className="checklist-icon"><img className="checklist-icon" src="/assets/img/checklist.png" alt="" /></div>
								<div className="checklist-header">PBN</div>
							</div>
							<div className="details">Performance Based Navigation</div>
						</div>
						<div className="col-sm checklist-item">
							<div className="checklist-container clearfix">
								<div className="checklist-icon"><img className="checklist-icon" src="/assets/img/checklist.png" alt="" /></div>
								<div className="checklist-header">RNP</div>
							</div>
							<div className="details">Required Navigation Performance</div>
						</div>
						<div className="col-sm checklist-item">
							<div className="checklist-container clearfix">
								<div className="checklist-icon"><img className="checklist-icon" src="/assets/img/checklist.png" alt="" /></div>
								<div className="checklist-header">NAT HLA</div>
							</div>
							<div className="details">North Atlantic High Level Airspace</div>
						</div>
						<div className="col-sm checklist-item">
							<div className="checklist-container clearfix">
								<div className="checklist-icon"><img className="checklist-icon" src="/assets/img/checklist.png" alt="" /></div>
								<div className="checklist-header">WATRS</div>
							</div>
							<div className="details">Western Atlantic Route System</div>
						</div>
						<div className="col-sm checklist-item">
							<div className="checklist-container clearfix">
								<div className="checklist-icon"><img className="checklist-icon" src="/assets/img/checklist.png" alt="" /></div>
								<div className="checklist-header">CPDLC</div>
							</div>
							<div className="details">Controller Pilot Data Link Communication</div>
						</div>
						<div className="col-sm checklist-item">
							<div className="checklist-container clearfix">
								<div className="checklist-icon"><img className="checklist-icon" src="/assets/img/checklist.png" alt="" /></div>
								<div className="checklist-header">PBCS</div>
							</div>
							<div className="details">Performance Based Communication Surveillance</div>
						</div>
					</div>
				</div>
			</div>
		</section>
    </div>
    <Footer />
  </div>
}

export default InternationalProcedures